import { z } from 'zod';
import { PositionSchema } from '../../shared/position.schema';
/**
 * Absolute canvas geometry of a note box (React Flow coordinates). Notes carry
 * their own geometry — unlike steps, whose positions live in the separate
 * `ProcessLayout` (`FlowPositionItem` is `{stepId,x,y}` only, no size).
 */ export const NoteGeometrySchema = PositionSchema.extend({
    width: z.number(),
    height: z.number()
});

//# sourceMappingURL=note-geometry.schema.js.map